import React, { useState, useCallback, useEffect, useMemo } from 'react';
import moment from 'moment';
import Filter from '@/pages/intelligence/components/Filter';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { feachTimeTypeToFilterTimeType } from '@/pages/intelligence/utils/common';
import { useIntl } from 'umi';
import { COMPETITOR_GUIDE_CLASSNAMES } from '@intelligence/components/UserGuide/Competitor';
import { getFilterExtendDefaultValue, updateInputListRegionOptions, updateInputListRangeTime } from '@intelligence/utils/filterUtils';
import { useUpdateFilterFormValues } from '@intelligence/hooks/useUpdateFilterFormValues';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';

export default function DigitalRevenueDetailFilter(props: any) {
  const {
    isTopCompanies = false,
    filterConfirm,
    filterReset,
    filterInit,
    buttonLogConfig,
    iconText,
    timeFilterValues,
    entityType,
    defaultSegementVal = 'All',
    defaultMarket = ['us'],
    onFilterInit,
    sinceReleaseTime,
    earliestDataTime,
    deviceDefVales,
    deviceOptions = [],
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法

  const hasDevice = entityType === 'console' || entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE;
  const defaultValue = {
    [filterKeyMap.RANGE_TIME]: {
      type: 'month',
      value: ['', ''],
    },
    [filterKeyMap.REGION]: {
      // regions: JSON.stringify(defaultMarket) === '["us"]' ? ['na'] : ['Global'],
      // markets: defaultMarket,
      // type: 'region',
      regions: [],
      markets: ['us'],
      type: 'region',
    },
    [filterKeyMap.DIGITAL_DEVICE]: {
      value: deviceDefVales,// getDeviceValuesByPageId('DigitalRevenue'),
    },
    [filterKeyMap.DIGITAL_SEGEMENT]: { value: defaultSegementVal },
  };
  // 继承逻辑在这写
  // formValue改成用ref，可提供给父组件回填时间， 或添加继承逻辑提供formValue给父组件
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend(
    {},
  );
  const extendDefaultFilterValue = getFilterExtendDefaultValue(isOperateDetail, detailFilterExtend, defaultValue);
  const [extendDefaultValue] = useState(!isOperateDetail
    ? defaultValue
    : {
      [filterKeyMap.RANGE_TIME]: extendDefaultFilterValue?.[filterKeyMap.RANGE_TIME],
      [filterKeyMap.REGION]: extendDefaultFilterValue?.[filterKeyMap.REGION],
      // 参与继承
      [filterKeyMap.DIGITAL_DEVICE]: {
        value:
          detailFilterExtend[filterKeyMap.DIGITAL_DEVICE]?.value ?? defaultValue[filterKeyMap.DIGITAL_DEVICE]?.value,
      },
      [filterKeyMap.DIGITAL_SEGEMENT]: {
        value:
          detailFilterExtend[filterKeyMap.DIGITAL_SEGEMENT]?.value ??
          defaultValue[filterKeyMap.DIGITAL_SEGEMENT]?.value,
      },
    });

  const [formValue, setFormValue] = useState(extendDefaultValue);

  const defaultInputList = {
    // {
    //   key: filterKeyMap.MY_FILTER,
    // },
    RANGE_TIME: {
      type: filterKeyMap.RANGE_TIME,
      key: filterKeyMap.RANGE_TIME,
      calendarType: 'month',
      earliestDataTime,
      sinceReleaseTime,
      isShowAlloftime: false,
    },
    REGION: {
      key: filterKeyMap.REGION,
      default: defaultValue[filterKeyMap.REGION],
      visible: 1,
      disableNoChina: true,
      globalInfo: formatMessage({ id: `dbi_info_global_filter2` }),
      // "popularList": [
      //   "br",
      //   "mx",
      //   "ru",
      //   "tr",
      //   "us"
      // ],
      options: [],
      isTopCompanies,
    },
    DIGITAL_SEGEMENT: {
      key: filterKeyMap.DIGITAL_SEGEMENT,
      default: defaultValue[filterKeyMap.DIGITAL_SEGEMENT],
      className: COMPETITOR_GUIDE_CLASSNAMES.ELEMENT5,
    },
    DIGITAL_DEVICE: {
      key: filterKeyMap.DIGITAL_DEVICE,
      type: filterKeyMap.CONSOLE_DEVICE,
      options: deviceOptions,
      default: defaultValue[filterKeyMap.DIGITAL_DEVICE],
    },
  };
  const list = [];
  list.push(defaultInputList.RANGE_TIME);
  list.push(defaultInputList.REGION);
  list.push(defaultInputList.DIGITAL_SEGEMENT);
  if (hasDevice) {
    list.push(defaultInputList.DIGITAL_DEVICE);
  }

  const [inputList, setInputList] = useState(list);

  /** 优化TODO：这一整块及inputList里的国家参数都放到model里 */
  const { filterLoading, regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.digitalRevenue,
  });

  useEffect(() => {
    if (onFilterInit instanceof Function) {
      onFilterInit({
        loading: filterLoading,
        regionOptions,
      });
    }
  }, [filterLoading, regionOptions]);

  useEffect(() => {
    /** 国家筛选器的列表值 */
    if (regionOptions) {
      const updateRegionOptionInput = updateInputListRegionOptions({
        inputList,
        regionOptions,
        regionKey: filterKeyMap.REGION,
      });
      setInputList(updateRegionOptionInput);
    }
  }, [regionOptions]);

  useEffect(() => {
    /** 更新时间筛选器快捷键 */
    if (inputList) {
      const updateOptionInput = updateInputListRangeTime({
        inputList,
        key: filterKeyMap.RANGE_TIME,
        earliestDataTime,
        sinceReleaseTime,
      });
      setInputList(updateOptionInput);
    }
  }, [earliestDataTime, sinceReleaseTime]);

  /** 时间筛选器值由父组件更新 */
  const combinedValues = useUpdateFilterFormValues({
    formValue,
    timeFilterValues,
  });

  useEffect(() => {
    setFormValue(combinedValues);
  }, [JSON.stringify(combinedValues)]);

  const onConfirm = useCallback(
    (value /** 筛选器数据 */, apiValue /** 筛选器转换后的数据 */) => {
      setFormValue(value);
      const filterForm: any = {
        // region_type: apiValue[filterKeyMap.REGION]?.region_type, //默认都是market
        regions: apiValue[filterKeyMap.REGION]?.markets,
        date_type: apiValue[filterKeyMap.RANGE_TIME]?.granularity,
        start_date: apiValue[filterKeyMap.RANGE_TIME]?.start_date,
        end_date: apiValue[filterKeyMap.RANGE_TIME]?.end_date,

        segment: value[filterKeyMap.DIGITAL_SEGEMENT]?.value,
      };
      if (hasDevice) {
        filterForm.device = value[filterKeyMap.DIGITAL_DEVICE]?.value;
      }
      filterConfirm(filterForm);
      setDetailFilterExtend(apiValue);
    },
    [filterConfirm],
  );

  return (
    <Filter
      value={formValue}
      inputList={inputList}
      onConfirm={onConfirm}
      onReset={() => { }}
      showButton={false}
      // iconText={iconText}
      defaultValue={defaultValue}
    />
  );
}
